import React, { Component } from 'react';
import { Modal } from 'antd';

class ImageModal extends Component {
    render() {
        const { visible, url, handleCancel } = this.props;

        console.log(url);

        return (
            <div>
                <Modal
                    title="Prescription"
                    style={{ textAlign: 'center' }}
                    width="70%"
                    visible={visible}
                    footer={null}
                    onCancel={handleCancel}
                >
                    <img
                        alt="Prescription"
                        src={url}
                        style={{ overflow: 'scroll' }}
                    // width="150"
                    // height="200"
                    />
                </Modal>
            </div>
        );
    }
}

export default ImageModal;



// WEBPACK FOOTER //
// ./src/component/UploadPrescriptionIMG/ImageModal.js